import './reset.css';
import './layout.css';

import React from 'react';

const Layout = (props: React.Props<React.ElementType>) => <>{props.children}</>;

export default Layout;
